import React, { useState } from "react";
import Select, { components } from "react-select";

import Form from "react-bootstrap/Form";

import clearIcon from "../../assets/icons/close-circled.svg";
import searchIcon from "../../assets/icons/search-icon.svg";

// react select control for contact attendees form
export default function MultiSelect({
  options,
  selectedArr,
  onChange,
  value,
  placeholder,
}) {
  const handleKeyDown = (e) => {
    // tab key is pressed, don't do anything
    if (e.key === "Tab") e.preventDefault();
  };

  // 👇 This moves the search icon (DropdownIndicator) to the LEFT
  const Control = ({ children, ...props }) => (
    <components.Control {...props}>
      <div style={{ marginLeft: 8 }}>
        <DropdownIndicator {...props} />
      </div>
      {children}
    </components.Control>
  );

  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ display: "flex" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Form.Check
              inline
              name="checkbox"
              type="checkbox"
              checked={props.isSelected}
              className="fw-medium"
              style={{ pointerEvents: "none" }}
              onChange={() => null}
            />
            <div className="select-label one">{props.data.label}</div>
          </div>
          <div className="select-label two">{props.data?.custom}</div>
        </div>
      </components.Option>
    );
  };

  const MultiValueLabel = (props) => {
    const {
      innerProps: { innerRef, ...innerProps },
    } = props;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="react-select__multi-value__label"
      >
        {props.data.chipLabel}
      </div>
    );
  };

  const Menu = (props) => {
    return (
      <components.Menu {...props}>
        <div className="react-select__menu__container">
          <div className="selected-count">{selectedArr?.length} selected</div>
          <div>{props.children}</div>
        </div>
      </components.Menu>
    );
  };

  const DropdownIndicator = (props) => {
    const {
      innerProps: { innerRef, ...innerProps },
    } = props;
    return (
      <img ref={innerRef} {...innerProps} src={searchIcon} alt="search icon" />
    );
  };

  const ClearIndicator = (props) => {
    const {
      innerProps: { innerRef, ...innerProps },
    } = props;
    return (
      <img ref={innerRef} {...innerProps} src={clearIcon} alt="clear icon" />
    );
  };

  return (
    <div className="select">
      <Select
        closeMenuOnSelect={false}
        isMulti
        isClearable
        hideSelectedOptions={false}
        options={options}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        value={value}
        placeholder={placeholder}
        components={{
          Control,
          MultiValueLabel,
          Menu,
          IndicatorSeparator: () => null,
          DropdownIndicator: () => null,
          ClearIndicator,
          Option,
        }}
        styles={{
          control: (base) => ({
            ...base,
            display: "flex",
            alignItems: "center",
            paddingRight: "12px",
            paddingLeft: "12px",
          }),
          indicatorsContainer: (base) => ({
            ...base,
            width: "25px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }),
          option: (baseStyles, { isFocused }) => ({
            ...baseStyles,
            color: "#23262F",
            backgroundColor: isFocused ? "#3e8bf71a" : null,
          }),
        }}
        className="react-select"
        classNamePrefix="react-select"
      />
    </div>
  );
}
